import React, { FC } from 'react';

import { List, Container, ContainerProps } from '@lglp/components';
import { useTranslation } from 'react-i18next';

import { COMMON } from 'translations';

import { ROUTE_KEY, getUrlForRouteKey } from '../../../config/routes';
import styles from './Breadcrumb.module.scss';
import { BreadcrumbLink } from './BreadcrumbLink';
import { BreadcrumbLinkContainer } from './BreadcrumbLinkContainer';

export const Breadcrumb: FC<BreadcrumbProps> = ({
  deprecatedStyle,
  className,
  documentId,
  documentType,
  ...rest
}) => {
  const { t, i18n } = useTranslation();
  const homeLink = getUrlForRouteKey(ROUTE_KEY.HOME, i18n.language);

  if (!documentId || !documentType) {
    return null;
  }

  return (
    <Container
      as="nav"
      className={[
        deprecatedStyle ? styles.deprecatedBreadcrumb : styles.breadcrumb,
        deprecatedStyle && 'wrapper fullbg-primary',
        className,
      ]}
      aria-label="breadcrumb"
      {...rest}
    >
      <List ordered>
        <>
          {homeLink && (
            <BreadcrumbLink url={homeLink} title={t(COMMON.BREADCRUMB_HOME)} />
          )}
          <BreadcrumbLinkContainer
            documentId={documentId}
            documentType={documentType}
            current={true}
          />
        </>
      </List>
    </Container>
  );
};

export type BreadcrumbProps = ContainerProps & {
  documentId?: string;
  documentType?: string;
  // To apply style of v1
  deprecatedStyle?: boolean;
};
